export type I18nBrand = 'default' | 'creverse' | 'b2g' | 'vine'

// domain 의 Academy 의 AcademyGroupType 와 같은 값 공간. shared 는 domain 을
// import 하면 순환참조라 구조적으로 다시 선언한다 (SSOT 참조는 소비처에서 한다).
type AcademyGroupType = 'CREVERSE' | 'WEIZMANN' | 'VINE' | null

export const resolveBrand = ({
  academyGroupType,
  customerType,
}: {
  academyGroupType?: AcademyGroupType
  customerType?: string | null
}): I18nBrand => {
  if (academyGroupType === 'CREVERSE') return 'creverse'
  if (academyGroupType === 'VINE') return 'vine'
  if (customerType?.includes('B2G')) return 'b2g'
  return 'default'
}
